import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeederComponent } from './components/feeder/feeder.component';
import { TimestampComponent } from './components/timestamp/timestamp.component';

const routes: Routes = [
  {path: '', component: FeederComponent, /*canActivate: [MsalGuard]*/},
  {path: 'timestamp', component: TimestampComponent, /*canActivate: [MsalGuard]*/},
  {path: '*', redirectTo: ''}
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
